import React from "react";
import ReactLoading from "react-loading";

const LoadingScreen: React.FC = () => {
  return (
    <>
      <div className="fixed top-0 left-0 bottom-0 right-0 z-10 flex items-center justify-center bg-gray-600 bg-opacity-40">
        <ReactLoading type="spokes" />
      </div>
    </>
  );
};

export default LoadingScreen;
